<template>
  <div class="Tchroadmap_all">
    <div class="tech-roadmap-container">
      <div class="top-bg">
        <div class="title">
          <div>DO Technology Roadmap</div>
        </div>
        <div class="sub-title">What we did about the technical route?</div>
        <div class="content-text">
          We're proud of what we've accomplished with our community so far — and
          look forward to tackling challenges and building more with a whole new
          generation of participants.
        </div>
        <div class="TechRoadmapSwiper">
          <TechRoadmapSwiper></TechRoadmapSwiper>
        </div>

        <!-- <div class="tech-2021">
          <div class="tech-p-text">
            <p>2021</p>
          </div>
          <div class="tech-2021-ul">
            <ul>
              <li>
                <p>{{ dateList[0].quarter }}</p>
                <p>{{ dateList[0].month }}</p>
                <p class="dianxian"></p>
                <p>{{ dateList[0].desc }}</p>
              </li>
              <li>
                <p>{{ dateList[1].quarter }}</p>
                <p>{{ dateList[1].month }}</p>
                <p class="dianxian"></p>
                <p>
                  {{ dateList[1].desc }}
                </p>
              </li>
              <li>
                <p>{{ dateList[2].quarter }}</p>
                <p>{{ dateList[2].month }}</p>
                <p class="dianxian"></p>
                <p>{{ dateList[2].desc }}</p>
              </li>
            </ul>
          </div>
        </div>
        <div class="tech-2021 tech-2022">
          <div class="tech-p-text">
            <p>2022</p>
          </div>
          <div class="tech-2021-ul">
            <ul>
              <li>
                <p>{{ dateList[3].quarter }}</p>
                <p>{{ dateList[3].month }}</p>
                <p class="dianxian"></p>
                <p>{{ dateList[3].desc }}</p>
              </li>
              <li>
                <p>{{ dateList[4].quarter }}</p>
                <p>{{ dateList[4].month }}</p>
                <p class="dianxian"></p>
                <p>{{ dateList[4].desc }}</p>
              </li>
              <li>
                <p>{{ dateList[5].quarter }}</p>
                <p>{{ dateList[5].month }}</p>
                <p class="dianxian"></p>
                <p>{{ dateList[5].desc }}</p>
              </li>
              <li>
                <p>{{ dateList[6].quarter }}</p>
                <p>{{ dateList[6].month }}</p>
                <p class="dianxian"></p>
                <p>{{ dateList[6].desc }}</p>
              </li>
            </ul>
          </div>
          <div class="tech-2021-ul">
            <ul>
              <li>
                <p>{{ dateList[7].quarter }}</p>
                <p>{{ dateList[7].month }}</p>
                <p class="dianxian"></p>
                <p>{{ dateList[7].desc }}</p>
              </li>
              <li>
                <p>{{ dateList[8].quarter }}</p>
                <p>{{ dateList[8].month }}</p>
                <p class="dianxian"></p>
                <p>{{ dateList[8].desc }}</p>
              </li>
              <li>
                <p>{{ dateList[9].quarter }}</p>
                <p>{{ dateList[9].month }}</p>
                <p class="dianxian"></p>
                <p>{{ dateList[9].desc }}</p>
              </li>
              <li>
                <p>{{ dateList[10].quarter }}</p>
                <p>{{ dateList[10].month }}</p>
                <p class="dianxian"></p>
                <p>
                  {{ dateList[10].desc }}
                </p>
              </li>
            </ul>
          </div>
        </div> -->
      </div>

      <!-- <div class="date-container"> -->
      <!-- <div class="date-component active-com">
        <div class="date-quarter"><p>Q4</p></div>
        <div class="date-month">month</div>
        <div class="blue-divide"></div>
        <div class="date-desc">
          Optimize the design of the project foundation frame.
        </div>
      </div> -->

      <!-- <div class="myswiper-container">
        <swiper :options="swiperOption" ref="mySwiper">  -->
      <!-- slides
          <swiper-slide v-for="(item, index) of dateList" :key="index">
            <div class="item-container">
              <div class="item-quarter">
                <p>{{ item.quarter }}</p>
              </div>
              <div class="item-month">{{ item.month }}</div>
              <div class="item-blue-divide"></div>
              <div class="item-desc">{{ item.desc }}</div>
            </div>
          </swiper-slide>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
          <div class="swiper-scrollbar" slot="scrollbar"></div>
        </swiper>
      </div>
    </div> -->
      <!-- 技术路线图 -->
    </div>
  </div>
</template>

<script>
import TechRoadmapSwiper from "./TechRoadmapSwiper.vue";
export default {
  components: {
    TechRoadmapSwiper,
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
  ul{
    list-style: none;
  }
  .Tchroadmap_all{
    width: 100%;
    height: 100%;
    margin-bottom: 168px;
  }
 .tech-roadmap-container {
  width: 1190px;
  margin: 0 auto;
  .top-bg {
    padding-top: 231px;
    margin: 0 auto;
    text-align: left;
    padding-left: 14px;
    .title {
      font-size: 80px;
      font-family: Poppins-Black, Poppins;
      font-weight: 900;
      color: #000000;
      line-height: 103px;
      -webkit-background-clip: text;
    }
    .sub-title {
      margin-top: 45px;
      font-size: 24px;
      font-family: Poppins-Medium, Poppins;
      font-weight: 500;
      color: #000000;
      line-height: 28px;
      -webkit-background-clip: text;
    }
    .content-text {
      font-size: 18px;
font-family: Poppins-Medium, Poppins;
font-weight: 500;
color: #61666B;
line-height: 30px;
-webkit-background-clip: text;
      // margin-bottom: 100px;
      margin-top: 22px;
    }
    .TechRoadmapSwiper{
      width: 100%;
    }
  }
  .tech-2021{
    width: 1200px;
    margin:  0 auto;
    text-align: center;
    .tech-p-text{
       width: 100%;
       font-size: 38px;
       font-family: Poppins-ExtraBold, Poppins;
       font-weight: 800;
       color: #000000;
       line-height: 45px;
       -webkit-background-clip: text;
    }
    .tech-2021-ul{
      width: 1200px;
      height: 270px;
      margin-top: 50px;
        li{
        float: left;
        width: 277px;
        height: 270px;
        background: rgba(251, 251, 251, 0.3);
        box-shadow: 0px 12px 26px 1px rgba(46, 87, 192, 0.05);
        border-radius: 14px 14px 14px 14px;
        opacity: 1;
        // border: 1px solid #FFFFFF;
        margin-right: 23px;
        box-sizing: border-box;
        padding: 25px 30px 42px 30px;
        margin-bottom: 40px;
          p{
            text-align: left;
            // line-height: 20px;
          }
          p:nth-child(1){
            font-size: 38px;
            font-family: Poppins-ExtraBold, Poppins;
            font-weight: 800;
            color: rgba(52, 51, 61, 0.08);
            line-height: 45px;
            -webkit-background-clip: text;
          }
          p:nth-child(2){
            font-size: 38px;
            font-family: Poppins-ExtraBold, Poppins;
            font-weight: 800;
            color: #000000;
            line-height: 45px;
            -webkit-background-clip: text;
            margin-bottom: 24px;
          }
          p:nth-child(4){
            margin-top: 29px;
            font-size: 12px;
            font-family: Poppins-Regular, Poppins;
            font-weight: 400;
            color: #B2B2B2;
            line-height: 18px;
            -webkit-background-clip: text;
          }
          .dianxian{
              width: 30px;
              height: 3px;
              background: #4573E7;
          }
        }
      }
    }
    .tech-2022{
      margin-top: 120px;
      margin-bottom: 167px;
    }
  }
/*//   .date-container {
//     display: flex;
//     // width: 380px;
//     height: 640px;
//     margin-top: -60px;
//     &:nth-last-child(1) {
//       margin-bottom: 100px;
//     }
//     .myswiper-container {
//       flex: 1;
//       margin: 0 30px;
//       width: 380px;
//       height: 640px;
//       border: 1px solid #f00;
//       overflow: hidden;
//       .item-container {
//         padding: 0 20px;
//         width: 380px;
//         height: 320px;
//         background: #eff2f8;
//         border-radius: 15px;
//         margin-bottom: 30px;
//         .item-quarter {
//           width: 67px;
//           height: 68px;
//           font-size: 45px;
//           font-family: Poppins-ExtraBold, Poppins;
//           font-weight: 800;
//           color: rgba(52, 51, 61, 0.08);
//           line-height: 68px;
//           -webkit-background-clip: text;
//         }
//         .item-month {
//           height: 68px;
//           font-size: 45px;
//           font-family: Poppins-ExtraBold, Poppins;
//           font-weight: 800;
//           color: #34333d;
//           line-height: 68px;
//           -webkit-background-clip: text;
//         }
//         .item-blue-divide {
//           margin-top: 15px;
//           width: 40px;
//           height: 4px;
//           background: #4573e7;
//           border-radius: 0px 0px 0px 0px;
//           opacity: 1;
//         }
//         .item-desc {
//           margin-top: 45px;
//           width: 280px;
//           height: 42px;
//           font-size: 14px;
//           font-family: Poppins-Regular, Poppins;
//           font-weight: 400;
//           color: #b2b2b2;
//           line-height: 21px;
//           -webkit-background-clip: text;
//         }
//       }
//     }
//     .date-component {
//       width: 620px;
//       height: 560px;
//       padding: 0 53px;
//       border: 3px solid #ffffff;
//       border-radius: 30px;
//       box-shadow: 0px 22px 51px 1px rgba(46, 87, 192, 0.05);
//       background: rgba(251, 251, 251, 0.3);
//       .date-quarter {
//         margin-top: 53px;
//         p {
//           height: 90px;
//           line-height: 90px;
//           font-size: 60px;
//           font-family: Poppins-ExtraBold, Poppins;
//           font-weight: 800;
//           color: rgba(52, 51, 61, 0.08);
//           -webkit-background-clip: text;
//         }
//       }
//       .date-month {
//         height: 90px;
//         line-height: 90px;
//         font-size: 60px;
//         font-family: Poppins-ExtraBold, Poppins;
//         font-weight: 800;
//         color: #34333d;
//         -webkit-background-clip: text;
//       }
//       .blue-divide {
//         margin-top: 47px;
//         width: 60px;
//         height: 6px;
//         background: #4573e7;
//       }
//       .date-desc {
//         margin: 50px 6px 0;
//         height: 80px;
//         font-size: 20px;
//         font-family: Poppins-Regular, Poppins;
//         font-weight: 400;
//         color: #b2b2b2;
//         line-height: 30px;
//         -webkit-background-clip: text;
//       }
//     }
//   }
// }*/
</style>
